export default __webpack_public_path__ + "static/media/marketing-background.90c4c7bc.svg";